var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5999 12.0308C15.1751 11.6206 13.6447 11.8068 12.3598 12.5467C10.6238 13.5465 8.53631 13.7332 6.65046 13.0574L4.26491 12.2026C3.91126 12.0759 3.72729 11.6864 3.85402 11.3328C3.98075 10.9791 4.37017 10.7952 4.72383 10.9219L7.10938 11.7767C8.61939 12.3178 10.2909 12.1683 11.6809 11.3678C13.2856 10.4437 15.1969 10.2111 16.9764 10.7235L19.194 11.3621C19.555 11.466 19.7634 11.8429 19.6594 12.204C19.5555 12.565 19.1785 12.7733 18.8175 12.6694L16.5999 12.0308Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7878 17.456C15.9809 17.039 14.0614 17.2426 12.373 18.0191C10.2556 18.9929 7.832 19.1884 5.58747 18.545L2.49295 17.6579C2.13182 17.5544 1.92299 17.1777 2.02651 16.8166C2.13004 16.4555 2.50671 16.2466 2.86784 16.3501L5.96236 17.2372C7.88985 17.7898 9.97895 17.6227 11.8046 16.7831C13.7629 15.8825 15.9896 15.6448 18.0937 16.1304L20.9726 16.7947C21.3386 16.8792 21.5669 17.2444 21.4824 17.6105C21.398 17.9765 21.0327 18.2048 20.6667 18.1203L17.7878 17.456Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7878 6.57242C15.9809 6.15543 14.0614 6.3591 12.373 7.13559C10.2556 8.10938 7.832 8.3049 5.58747 7.66147L2.49295 6.77437C2.13182 6.67085 1.92299 6.29417 2.02651 5.93304C2.13004 5.57191 2.50671 5.36308 2.86784 5.4666L5.96236 6.3537C7.88985 6.90624 9.97895 6.73918 11.8046 5.89959C13.7629 4.99897 15.9896 4.76125 18.0937 5.24682L20.9726 5.91117C21.3386 5.99564 21.5669 6.36087 21.4824 6.72692C21.398 7.09298 21.0327 7.32124 20.6667 7.23677L17.7878 6.57242Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.e7ad51b373b84fa528a1e100bcae2e34.svg";
export { ForwardRef as ReactComponent };